import { render, staticRenderFns } from "./documents-tab.vue?vue&type=template&id=2d1be1d4&"
import script from "./documents-tab.vue?vue&type=script&lang=js&"
export * from "./documents-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports